export default __webpack_public_path__ + "static/media/pin.a23d395c.png";